import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import CropTypeForm from "components/agro/cropTypes/CropTypeForm";
import { updateCropType } from "graphql/mutations";
import { getCropType } from "graphql/queries";

const CropTypeUpdateForm = ({ cropTypeId, onSuccess }) => {
  const [cropType, setCropType] = useState();

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        companyID,
        cropUnitID,
      } = valuesParam;

      await API.graphql({
        query: updateCropType.replaceAll("__typename", ""),
        variables: {
          input: {
            id: cropTypeId,
            name,
            companyID,
            cropUnitID,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error(strings.responses.errorUpdate);
      console.error(err);
    }
  }

  async function fetchCropType(id) {
    try {
      const cropTypeData = await API.graphql(graphqlOperation(getCropType, { id }));
      const cropTypeItem = cropTypeData.data.getCropType;
      if (!cropTypeItem) {
        toast.error(strings.responses.errorFetch);
        return;
      }
      setCropType({
        ...cropTypeItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchCropType(cropTypeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cropTypeId]);

  if (!cropType) return <Loader />;

  return (
    <div>
      <CropTypeForm onSubmit={onSubmit} type="update" initialValues={cropType} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    successUpdated: "Tipo de Cultivo actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar el tipo de cultivo",
      errorUpdate: "Error al actualizar tipo de cultivo",
    },
  },
});

export default CropTypeUpdateForm;
